import { RICH_TEXT_BLANK } from './index';
export default function fixControlledValue(value, richText) {
  if (value === null || value === undefined) {
    return '';
  } // 富文本编辑器，无内容直接插入视频，需手动补充空行至视频后，修复无法删除视频问题


  if (richText && value.endsWith('</video>')) {
    return "".concat(value).concat(RICH_TEXT_BLANK);
  }

  return value;
}